import { trackingBatcher } from "@b2bportal/core-tracking/batcher";
import type { TrackEventRequest } from "@b2bportal/event-tracking-api";
import type { IApiConfig } from "@hopper-b2b/types";

import { analyticsApiPrefix } from "../paths";

export const trackEvent = (
  request: TrackEventRequest,
  config?: IApiConfig
): Promise<boolean> => {
  const analyticsApi = config?.analyticsApiPrefix || analyticsApiPrefix;
  const endpoint = `${analyticsApi}/event`;

  const req: TrackEventRequest = request.eventName.startsWith("w1_")
    ? request
    : {
        ...request,
        eventName: `w1_${request.eventName}`,
      };

  if (
    (!import.meta.env.PROD || import.meta.env.VITE_DEVTOOL === "true") &&
    typeof window !== "undefined"
  ) {
    const buf = ((window as any).__DEVTOOL_TRACKING_BUFFER__ ??= []);
    const entry = {
      eventName: req.eventName,
      properties: req.properties,
      source: "trackEvent",
      timestamp: Date.now(),
      status: "pending" as string,
    };
    buf.push(entry);
    if (buf.length > 500) buf.splice(0, buf.length - 500);

    return trackingBatcher.enqueue(req, endpoint, (status) => {
      entry.status = status;
    });
  }

  return trackingBatcher.enqueue(req, endpoint);
};
